import moment from 'moment';

const yearSensitiveDateString = (
  timestamp: Date | string,
  format = 'MMMM D',
  compare: number | Date = moment().valueOf(),
) => {
  const timestampMoment = moment(timestamp);
  const compareMoment = moment(compare);
  const shouldShowYear = timestampMoment.year() !== compareMoment.year();
  return timestampMoment.format(shouldShowYear ? `${format}, YYYY` : format);
};

export default yearSensitiveDateString;
